import { useEffect, useState } from "react";

import { useStoreContext } from "../contexts/StoreDataContext";
import { getPublicServerEndpoint } from "../services/helper";
import StoreItem from "./StoreItem";

const SimilarProducts = ({ collectionId, currentProductId }) => {
  const context = useStoreContext();
  const storeId = context?.storeData?.id;

  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSimilarProducts = async () => {
      setIsLoading(true);

      try {
        const url = `${getPublicServerEndpoint()}/v3/product/store/${storeId}/collectionv2?page=1&limit=10&source=web&collectionId=${collectionId}`;

        const response = await fetch(url);
        const data = await response.json();

        // filter out the current product from the list
        const filteredProducts = data.data.docs.filter(
          (product) => product.id !== currentProductId,
        );

        setProducts(filteredProducts);
      } catch (err) {
        console.log("🚀 ~ fetchSimilarProducts ~ err:", err);
        setProducts([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSimilarProducts();
  }, [collectionId, storeId, currentProductId]);

  if (isLoading) return <div>Loading Similar Products...</div>;
  if (products.length === 0) return null;

  return (
    <div className="mt-6 px-6">
      <h4 className="text-lg font-semibold">Similar Products</h4>

      <div className="hide-scrollbar mt-6 flex flex-row overflow-x-auto overflow-y-hidden">
        {products.map((product, index) => (
          <div
            key={product.id}
            className="flex-shrink-0"
            style={{
              width: "140px",
              marginRight: index !== products.length - 1 ? "16px" : "0px",
            }}
          >
            <StoreItem
              // cohort={cohort}
              usedForCollectionhome={true}
              product={product}
              pageSize={products.length}
              customHeightWidth="h-[180px] w-[140px]"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimilarProducts;
